export const Colors = {
    White: 0xffffff,
    Blue1: 0xBCCCDC,
    Blue2: 0x486581,
    Gray: 0x808080,
};

export const LegoColors = {
    Green: 0x90EE90,
    Red: 0xC91A09,
    Blue: 0x0055BF,
    LightBlue: 0xB4D2E3,
    Pink: 0xC870A0,
    DarkPink: 0xDF6695,
    Lavendar: 0xAC78BA,
    Orange: 0xFE8A18,
    LightOrange: 0xF3CF9B,
    Yellow: 0xF8F184,
    Gold: 0xDBAC34,
    Violet: 0x6874CA,
    LightLime: 0xD9E4A7,
    LightGray: 0xABADAC,
}

export const LegoDimensions = {
    Width: 49,
    Height: 49,
    Depth: 49,
};
